module.exports = __webpack_public_path__ + "static/img/EOMAP_detect_logo.8d61f769.jpg";